<template>
    <div>
        <GenericCrud
            route-name="SettingsGroupsOfPerson"
            route-action="list"
            :navbar-title="$t('settings.groupsOfPersons.buttonLabel')"
            :navbar-back-route-without-history="{ name: 'Settings' }"
            :main-list-filter-label="$t('settings.groupsOfPersons.filterLabel')"
            main-fist-scroll-to-selected
            :new-item-model-fields="{
                clientId: null,
                locale: currentLanguage,
                translations: defaultTranslations

            }"
            :store-data="{
                store: 'groupsOfPersons',
                mainListItems: {
                    action: 'groupsOfPersons/fetch',
                    payload: { force: true },
                    options: null,
                    itemText: 'title'
                },
                mainItemById: {
                    action: 'groupsOfPersons/fetchById',
                    payload: null,
                    options: null,
                },
                edit: {
                    action: 'groupsOfPersons/edit',
                    payload: null,
                    options: null,
                    refetch: true,
                    hideButton: true
                },
                add: {
                    action: 'groupsOfPersons/create',
                    payload: null,
                    options: null,
                },
                delete: {
                    action: 'groupsOfPersons/delete',
                    payload: null,
                    options: null,
                    hideButton: true
                },
                findUsage: {
                    action: 'groupsOfPersons/findUsage',
                    payload: null,
                    options: null,
                    hideButton: true
                },
                replace: {
                    action: 'groupsOfPersons/replaceItemInRecord',
                    options: null,
                    hideButton: true
                },
            }"
        >
            <template v-slot:editorMask="x">
                <EditorMask
                    v-model="x.selectedMainItem"
                    :key="x.id"
                    :available-languages="availableLanguages"
                    :current-language="currentLanguage"
                    :isWaiting="x.isWaiting"
                    :isModified="x.isModified"
                    @modified="x.onSetModified"
                    @onSaveItem="x.onSaveItem"
                    @onDeleteItem="x.onDeleteItem"
                    @onFindUsage="x.onFindUsage"
                    @onCreateItem="x.onCreateItem"
                    />
            </template>
        </GenericCrud>
    </div>
</template>

<script>
import GenericCrud from '@/components/generic/GenericCrud.vue';
import EditorMask from './EditorMask.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'SettingsGroupsOfPersonsIndex',
    components: {
        GenericCrud,
        EditorMask,
    },
    i18n: {
        messages: {
            en: require('@/locales/Settings/en.json'),
            de: require('@/locales/Settings/de.json'),
        },
    },
    computed: {
        ...mapGetters({
            availableLanguages: 'languageSettings/getAvailableLanguages',
            currentLanguage: 'languageSettings/getCurrentLanguage'
        }),
        defaultTranslations() {
            let translations = this.availableLanguages.map(x => {
                return { title: '', locale: x};
            });
            
            return translations.sort((a, b) => {
                return (b.locale === this.currentLanguage && a.locale !== this.currentLanguage) ? 1 : -1;
            });
        }
    }
};
</script>
